'use client'

import {createContext, useEffect, useState} from 'react'
import Cookies from 'js-cookie'
import {urlParamsToObject, handleToken} from '@utils/helpers'
import {getBalance} from '@/services/header/account'

type AuthContextType = {
  isAuthenticated: boolean,
  user: OnliveUser,
  authLoading: boolean,
  accountBalance: number,
  setAccountBalance: Function,  
}

export const AuthContext = createContext({} as AuthContextType)

const AuthProvider = ({children}: {children: React.ReactNode}) => {
  const [user, setUser] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [accountBalance, setAccountBalance] = useState<number>(0)

  const handleLogin = async () => {
    await handleToken()
    const cookieUser = Cookies.get('PdboxUser')
    const pdboxTicket = Cookies.get('PdboxTicket')
    const accessToken = Cookies.get('access_token')
    if (!accessToken || !pdboxTicket) {
      return
    }
    let userData = cookieUser ? urlParamsToObject(cookieUser as string) : null

    if (userData && pdboxTicket) {
      userData = {...userData, pdboxTicket: pdboxTicket}
    }
    if (accessToken && accessToken?.length > 0) {
      userData = {...userData, accessToken: accessToken}
    }
    const balance = await getBalance(accessToken)
    setAccountBalance(balance)
    setUser(userData)
    setLoading(false)
  }

  useEffect(() => {
    handleLogin()
  }, [])

  return (
    <AuthContext.Provider
      value={{
        user,
        accountBalance,
        setAccountBalance,
        isAuthenticated: !!user,
        authLoading: loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
